<template>
  <modal name="modal-edit-usertype" height="auto" :width="400"
    :scrollable="true" :clickToClose="false" @closed="$emit('input', false)">
    <div class="modal-head mb-3">
      <h4>EDIT USER TYPE</h4>
      <a href="javascript:;" class="close" @click="closeModal"></a>
    </div>
    <form method="post" @submit.prevent="doSave">
      <div class="form-group">
        <label for="title">Title <span class="text-danger">*</span></label>
        <input type="text" name="title" id="title" ref="inputTitle"
               :class="{'form-control': true, 'is-invalid': errors.has('title')}"
               v-validate.disable="{ required: true }"
               v-model="title">
        <div class="invalid-feedback">{{ errors.first('title') }}</div>
      </div>

      <div class="form-group">
        <label for="color_class">Color</label>
        <select name="color_class" id="color_class"
                :class="['form-control']" v-model="color_class">
          <option class="text-white bg-secondary" value="">Default</option>
          <option class="text-white bg-primary" value="primary">Blue</option>
          <option class="text-white bg-success" value="success">Green</option>
          <option class="text-white bg-info" value="info">Cyan</option>
          <option class="text-white bg-warning" value="warning">Yellow</option>
          <option class="text-white bg-danger" value="danger">Red</option>
        </select>
      </div>

      <div class="pt-2 btns btns-2">
        <beat-loader v-if="state == 'saving'"></beat-loader>
        <template v-else>
          <button type="submit" class="btn btn-outline-black mr-2">Save Changes</button>
          <button type="button" class="btn btn-outline-secondary" @click="closeModal">Cancel</button>
        </template>
      </div>
    </form>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import BeatLoader from 'vue-spinner/src/BeatLoader'

import ServiceUserType from '@/services/usertype'

export default {
  components: {
    BeatLoader,
  },
  data () {
    return {
      state: '',
      title: '',
      color_class: '',
    }
  },
  props: ['value', 'usertype'],
  computed: mapState({
  }),
  watch: {
    usertype: 'init',
    value ( newVal ) {
      let self = this;
      if ( newVal ) {
        this.$modal.show('modal-edit-usertype', {});
        setTimeout(() => {
          self.$refs.inputTitle.focus();
        }, 200);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      if ( !self.usertype ) {
        return;
      }
      self.title = self.usertype.title;
      self.color_class = self.usertype.color_class;
    },
    closeModal () {
      this.$modal.hide('modal-edit-usertype');
    },
    doSave ( ) {
      let self = this;

      if ( self.state == 'saving' ) {
        return;
      }

      let postData = {};

      if ( self.title != self.usertype.title )
        postData.title = self.title;

      if ( self.color_class != self.usertype.color_class )
        postData.color_class = self.color_class;

      self.state = 'saving';
      ServiceUserType.save(self.usertype.id, postData, userType => {
        self.state = '';
        self.$notify({
          type: 'success',
          text: 'User type updated'
        });
        self.$emit('usertype-saved', userType);
        self.closeModal();
      }, () => {
        self.state = '';
      });
    }
  }
}
</script>
